import goalDistribution from './goal-distribution.json';
import goalContributionSuccess from './goal-contribution-success.json';

export default {
  'contribute-goals': {
    ...goalDistribution,
    ...goalContributionSuccess,
  },
};
